import { LogIn, ShieldCheck, ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AdminLogin() {
  const handleLogin = () => {
    // Redirect must be dynamic — comes back to /admin on the same origin
    const redirectUrl = window.location.origin + "/admin";
    window.location.href =
      "https://auth.emergentagent.com/?redirect=" +
      encodeURIComponent(redirectUrl);
  };

  return (
    <main
      data-testid="admin-login-page"
      className="min-h-screen flex items-center justify-center bg-slate-50 px-6"
    >
      <div className="max-w-md w-full">
        <Link
          to="/"
          data-testid="admin-back-home-link"
          className="inline-flex items-center gap-2 text-sm text-slate-600 hover:text-slate-900 mb-8"
        >
          <ArrowLeft className="w-4 h-4" />
          Back to site
        </Link>

        <div className="bg-white border border-slate-200 rounded-2xl shadow-sm p-10">
          <div className="w-14 h-14 rounded-xl bg-[#1E56B8]/10 flex items-center justify-center mb-6">
            <ShieldCheck className="w-7 h-7 text-[#1E56B8]" />
          </div>
          <h1 className="text-3xl font-bold text-slate-900 tracking-tight">
            DazTec Admin
          </h1>
          <p className="mt-3 text-base text-slate-600 leading-relaxed">
            Sign in with your Google account to view and manage customer
            enquiries. Access is restricted to authorised accounts only.
          </p>

          <button
            onClick={handleLogin}
            data-testid="admin-google-login-button"
            className="mt-8 w-full inline-flex items-center justify-center gap-3 h-14 rounded-xl bg-slate-900 hover:bg-slate-800 text-white font-semibold text-lg shadow-md hover:-translate-y-0.5 transition-all"
          >
            <LogIn className="w-5 h-5" />
            Sign in with Google
          </button>

          <p className="mt-6 text-xs text-slate-500 leading-relaxed">
            You&apos;ll be redirected to Google to sign in, then back to this
            dashboard. If your email isn&apos;t authorised, you&apos;ll see a friendly
            error — no fuss.
          </p>
        </div>
      </div>
    </main>
  );
}
